declare global {
  interface Window {
    dataLayer?: unknown[]
    gtag?: (...args: unknown[]) => void
  }
}

let loadPromise: Promise<void> | null = null

function loadGtag(conversionId: string): Promise<void> {
  if (loadPromise) return loadPromise
  loadPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = `https://www.googletagmanager.com/gtag/js?id=${conversionId}`
    script.async = true
    script.onload = () => resolve()
    script.onerror = () => reject(new Error('Failed to load gtag.js'))
    document.head.appendChild(script)

    window.dataLayer = window.dataLayer || []
    window.gtag = function gtag(...args: unknown[]) {
      window.dataLayer!.push(args)
    }
    window.gtag('js', new Date())
    window.gtag('config', conversionId)
  })
  return loadPromise
}

export function useGoogleAdsConversion(conversionId: string | null | undefined) {
  async function fireConversion(label: string) {
    if (!conversionId || !import.meta.env.PROD) return
    await loadGtag(conversionId)
    window.gtag?.('event', 'conversion', { send_to: `${conversionId}/${label}` })
  }

  return { fireConversion }
}
